import { LocalOperation } from 'hooks/store/types';
import { useDispatch } from 'hooks/utils';
import { appendFormElement, AppendFormElementAction } from 'store/data/forms';
import { ActionPayload } from 'store/types';

export function useAppendFormElement(): LocalOperation<
	(payload: ActionPayload<AppendFormElementAction>) => void
> {
	const dispatch = useDispatch();

	function handler(payload: ActionPayload<AppendFormElementAction>) {
		dispatch(appendFormElement(payload));
	}

	return handler;
}
